export default __webpack_public_path__ + "static/media/clipboard.b215cf8b.svg";